import React from 'react';
import { render } from 'react-dom';
import { Provider } from 'react-redux';
import { store } from '../../store';

/* 
  The purpose of this file is to provide us a way to render the sidebar without
  affecting the autogenerated styled-component classes on the methods page.
  The styled-component classes are sensitive to changes in the import order.
*/

const node = document.createElement('div');
document.body.appendChild(node);

export const renderProductSelectionSidebar = async ({ itemSidebarUpdate, renderCallback }) => {
  const module = await import(
    /* webpackChunkName: "product-selection-sidebar" */ `./ProductSelectionSidebar`
  );
  const ProductSelectionSidebar = module.default;
  render(
    <Provider store={store}>
      <ProductSelectionSidebar itemSidebarUpdate={itemSidebarUpdate} />
    </Provider>,
    node,
    renderCallback,
  );
};
